import { render, staticRenderFns } from "./MedicalInformation.vue?vue&type=template&id=93c461b6&scoped=true"
import script from "./MedicalInformation.vue?vue&type=script&lang=js"
export * from "./MedicalInformation.vue?vue&type=script&lang=js"
import style0 from "./MedicalInformation.vue?vue&type=style&index=0&id=93c461b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c461b6",
  null
  
)

export default component.exports